import { BREAKPOINTS, type Breakpoint, useMediaQuery } from "./useMediaQuery";

export const useIsMobile = (breakpoint: Breakpoint = "lg"): boolean =>
  !useMediaQuery(`(min-width: ${BREAKPOINTS[breakpoint]})`);
